<template>
    
    <router-link v-if="hasPermission('fiche_member') && memberUUID" class="bg-none"
        :to="{ name: 'fiche', params: { clubUUID: clubUUID, memberUUID: memberUUID } }">
        <span class="badges  badges-route">
            {{ matricule }}
        </span>
    </router-link>
    <div v-else>
        <span class="badges badges-route">
            {{ matricule }}
        </span>
    </div>
</template>

<script setup lang="ts">
import { ref, defineProps } from 'vue';
import { clubUUID } from '@/shared/state';
import { usePermission } from "@/composables/auth/usePermission";

const props = defineProps({
    memberUUID: {
        type: String,
        default: '',
    },
    matricule: {
        type: String,
        default: '',
    }
});

const memberUUID = ref(props?.memberUUID);
const matricule = ref(props?.matricule);

const { hasPermission } = usePermission();

</script>

<style>
.bg-none {
    background: none !important;
}
</style>